class Share {
  constructor(el) {
    this.el = el;
    this.shareItems = this.el.querySelectorAll('[data-share-item]');
    this.title = this.el.getAttribute('data-share-title');
    this.description = this.el.getAttribute('data-share-description');
    this.url = this.el.getAttribute('data-share-url') ? this.el.getAttribute('data-share-url') : window.location.href;
    this.width = 680;
    this.height = 440;

    this.init();
  }

  init() {
    this.initEvents();
  }

  initEvents() {
    for(let i = 0; i < this.shareItems.length; i++) {
      this.shareItems[i].addEventListener('click', (e) => this.handleClick(e));
    }
  }

  handleClick(e) {
    const type = e.target.parentNode.getAttribute('data-share-item');
    const target = this.targetUrl(type);
    this.popupHandler(e, target);
  }

  targetUrl(shareType) {
    let t;

    switch(shareType) {
      case 'facebook':
        t = `https://www.facebook.com/sharer/sharer.php?u=${this.url}`;
        break;
      case 'twitter':
        t = `https://twitter.com/intent/tweet?url=${this.url}&text=${this.title}&hashtags=MyMicrogap`;
        break;
      case 'whatsapp':
        t = `whatsapp://send?text=${this.title}%20${this.url}`;
        break;
    }

    return encodeURI(t);
  }

  popupHandler(e, targetUrl) {

    // popup position
    const px = Math.floor(((screen.availWidth || 1024) - this.width) / 2),
          py = Math.floor(((screen.availHeight || 700) - this.height) / 2);

    // open popup
    const popup = window.open(targetUrl, "social", 
      "width="+this.width+",height="+this.height+
      ",left="+px+",top="+py+
      ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
    if (popup) {
      popup.focus();
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }

    return !!popup;
  }
}

export default Share;